import { boolean, object, string } from "yup";

import { StatusEnum } from "../../shared";
import { PlatformEnum } from "../platform";

export const DEFAULT_VALUES = {
  name: "",
  username: "",
  email: "",
  platform: PlatformEnum.POS,
  status: StatusEnum.ACTIVE,
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  username: string().required("Harus diisi"),
  email: string().email("Email tidak valid").required("Harus diisi"),
  role: object().required("Harus diisi"),
  platform: string().required("Harus diisi"),
  status: boolean().required("Harus diisi"),
});
